// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notApproved .el-tag[data-v-63fdc7fc] {\r\n    color: #409eff;\n}\n.Approved .el-tag[data-v-63fdc7fc] {\r\n    background-color: #f0f9eb !important;\r\n    color: #67c23a !important;\r\n    border-color: #fef0f0;\n}\n.FailApproved .el-tag[data-v-63fdc7fc] {\r\n    background-color: #ffc0cb !important;\r\n    color: #ff1493 !important;\r\n    border-color: #f0f9eb;\n}\r\n", ""]);
// Exports
module.exports = exports;
